import chaseLogo from '@shared-images/icons/proforma-modal/chase.svg'
import wiseLogo from '@shared-images/icons/proforma-modal/wise.svg'
import revolutLogo from '@shared-images/icons/proforma-modal/revolut.svg'
import tetherLogo from '@shared-images/icons/proforma-modal/tether.svg'
import airwallexLogo from '@shared-images/icons/proforma-modal/airwallex.svg'
import pingpongLogo from '@shared-images/icons/proforma-modal/pingpong.svg'
import dbsLogo from '@shared-images/icons/proforma-modal/dbs.svg'
import wiseQrCode from '@shared-images/icons/proforma-modal/wise_qr_code.png'

// Payment-method blocks, rendered top-to-bottom in this order.
export const PAYMENT_TYPE_GROUPS = [
  {key: 'wire', label: 'Wire'},
  {key: 'payment_system', label: 'Payment Systems'},
  {key: 'crypto', label: 'Crypto'},
]

// Per payment-type presentation metadata, keyed by the CompanyInvoicePaymentType value.
// Tags come from the requisites endpoint; `qr` is a frontend image asset.
export const paymentTypeMeta = {
  p2w_us: {group: 'wire', brand: 'Chase', logo: chaseLogo},
  wise: {group: 'wire', brand: 'Wise', logo: wiseLogo},
  p2w_europe_wise_usd: {
    group: 'wire',
    brand: 'Wise',
    logo: wiseLogo,
    qr: wiseQrCode,
  },
  p2w_europe_revolut_usd: {group: 'wire', brand: 'Revolut', logo: revolutLogo},
  p2w_europe_revolut_eur: {group: 'wire', brand: 'Revolut', logo: revolutLogo},
  p2w_europe_revolut_gbp: {group: 'wire', brand: 'Revolut', logo: revolutLogo},
  crypto: {group: 'crypto', brand: 'Tether', logo: tetherLogo},
  airwallex: {group: 'payment_system', brand: 'Airwallex', logo: airwallexLogo},
  airwallex_dbs_sgp: {
    group: 'wire',
    brand: 'DBS Bank Ltd',
    logo: dbsLogo,
    fee: {
      label: '+0.3%',
      tooltip: 'Point2Web charges a 0.3% fee on incoming payments via DBS.',
    },
    hint: 'Use these details for international bank transfers sent via the SWIFT network.',
  },
  pingpong: {group: 'payment_system', brand: 'PingPong', logo: pingpongLogo},
}

export const getPaymentTypeMeta = value => paymentTypeMeta[value] ?? null
